import { render } from "./BaseSection.vue?vue&type=template&id=6e84c4b3"
const script = {}

import exportComponent from "/opt/build/repo/shark1x2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__